var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.options.length)?_c('iw-input-select',{ref:"inputSelect",attrs:{"id":"select-packs-duration","input-label":_vm.$t('select_duration'),"input-optional":false,"options":_vm.options},on:{"update-value":_vm.selectDuration}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }